// extracted by mini-css-extract-plugin
module.exports = {"fallback":"ModuleErrorFallback_fallback__wXTgI","container":"ModuleErrorFallback_container__IP6I7","actions":"ModuleErrorFallback_actions__zwk7c"};